import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Eject = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Eject' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M21,14 L12,2 L3,14 L21,14 Z M2,22 L22,22 L22,18 L2,18 L2,22 Z' />
  </StyledIcon>
);
